import React from "react";
import { Link, useHistory } from "react-router-dom";
import { Navbar, Container, Nav, Button } from "react-bootstrap";
import { useTheme } from "../../contexts/ThemeContext";
import "../../styles/header.css";

const PublicHeader = () => {
  const history = useHistory();
  const { theme } = useTheme();

  return (
    <Navbar
      bg={theme === 'dark' ? 'dark' : 'white'}
      variant={theme === 'dark' ? 'dark' : 'light'}
      expand="lg"
      className="shadow-sm sticky-top"
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img src="/Marion livraison pano.png" alt="Marion" style={{ height: 'auto', maxWidth: '100px', width: '100%' }} />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link as={Link} to="/" className="me-3">
              Accueil
            </Nav.Link>
            <Nav.Link as={Link} to="/faq" className="me-3">
              FAQ
            </Nav.Link>
            <Nav.Link as={Link} to="/about" className="me-3">
              À propos
            </Nav.Link>
            <Button
              variant="outline-primary"
              className="me-2 btn-outline-marion"
              onClick={() => history.push("/register")}
            >
              Créer un compte
            </Button>
            <Button
              variant="primary"
              className="btn-marion"
              onClick={() => history.push("/login")}
            >
              Passer une livraison
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default PublicHeader;
